import { call, put } from "redux-saga/effects";

import { 
    getEpeErrorCodesSuccess, getEpeErrorCodesFailure,
    getEpeLogsSuccess, getEpeLogsFailure
} from "../components/epe/redux/actions";

import ServiceRestartLogsService from "../components/epe/ServiceRestartLogsService";

const serviceRestartLogsService = new ServiceRestartLogsService();

/**
 * Worker saga for loading all error codes
 */
function* loadServiceRestartErrorCodes() {
    try {
        const errorCodeList = yield call(serviceRestartLogsService.getEpeErrorCodes)
        yield put(getEpeErrorCodesSuccess(errorCodeList));
    }
    catch(error) {
        yield put(getEpeErrorCodesFailure(error.toString()))
    }
}

/**
 * Worker saga for loading epe logs
 */
function* loadServiceRestartLogs({errorCodes, startDate, endDate, offset}) {
    try {
        const epeLogs = yield call(serviceRestartLogsService.getEpeLogs, errorCodes, startDate, endDate, offset);
        yield put(getEpeLogsSuccess(epeLogs));
    }
    catch(error) {
        yield put(getEpeLogsFailure(error.toString()));
    }
}

export { loadServiceRestartErrorCodes, loadServiceRestartLogs };